import React from "react";
import Pill from "../../shared/helpers/Pill";
import { formatDateReadable } from "../../utilities/helpers";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ArchiveOutlinedIcon from "@mui/icons-material/ArchiveOutlined";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import PendingTableEmployeeRowShiftDropDrawer from "./PendingTableEmployeeRowShiftDropDrawer";
import PendingTableEmployeeRowShiftPickupDrawer from "./PendingTableEmployeeRowShiftPickupDrawer";

function PendingTableEmployeeRowShift(props) {

  let cardStatus = "";
  if (
    props.rescinded_by === "employee-drop" &&
    props.requestType === "Pickup Request"
  ) {
    cardStatus = "rescinded (them)";
  } else if (
    props.rescinded_by === "employee-drop" &&
    props.requestType === "Add to Pool Request"
  ) {
    cardStatus = "rescinded";
  } else if (props.rescinded_by === "employee-pickup") {
    cardStatus = "rescinded";
  } else if (props.acting_manager_response === "approved") {
    cardStatus = "approved";
  } else if (props.acting_manager_response === "pending") {
    cardStatus = "pending";
  } else if (props.acting_manager_response === "denied") {
    cardStatus = "denied";
  } else {
    cardStatus = "";
  }


  const [isDrawerOpenDrop, setDrawerOpenDrop] = React.useState(false);

  const toggleDrawerDrop = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpenDrop(open);
  };

  const [isDrawerOpenPickup, setDrawerOpenPickup] = React.useState(false);

  const toggleDrawerPickup = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpenPickup(open);
  };

  return (
    <>
      <tr
        className="hover:bg-slate-50 cursor-pointer transition-colors"
        onClick={
          props.requestType === "Add to Pool Request"
            ? toggleDrawerDrop(true)
            : toggleDrawerPickup(true)
        }
      >
        <td className="whitespace-nowrap px-3 py-3.5 text-sm pl-6">
          <div className="flex items-center space-x-2">
            {props.requestType === "Add to Pool Request" ? (
              <div className="w-9 h-9 bg-slate-200 rounded-full flex items-center justify-center">
                <CloudDownloadOutlinedIcon sx={{ fontSize: 18, color: "#475569" }} />
              </div>
            ) : (
              <div className="w-9 h-9 bg-slate-200 rounded-full flex items-center justify-center">
                <PersonAddAltIcon sx={{ fontSize: 18, color: "#475569" }} />
              </div>
            )}
            <div className="font-semibold text-slate-900 text-sm">{props.requestType === "Add to Pool Request" ? "Drop Request" : props.requestType}</div>
          </div>
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm pl-6">
          <div className="font-semibold text-slate-900">{formatDateReadable(props.date)}</div>
          <div className="text-slate-500 text-xs mt-0.5">{props.shift}</div>
          <div className="text-slate-500 text-xs">
            {props.station
              ? props.station?.name
              : props.role
              ? props.role
              : props.roleType}
          </div>
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm">
        </td>
        <td className="whitespace-nowrap px-3 py-3.5 text-sm">
        </td>
        <td className="relative whitespace-nowrap py-3.5 pl-3 pr-6 text-right text-sm font-medium">
        </td>
        <td className="relative whitespace-nowrap py-3.5 pl-3 pr-6 text-right text-sm font-medium">
          <div className="flex items-center justify-end gap-x-3">
            <Pill status={cardStatus} />
            <div className="w-10 flex items-center justify-center">
              {cardStatus !== "pending" ? (
                <Tooltip title="Archive">
                  <IconButton
                    className="text-slate-400"
                    sx={{ backgroundColor: "#f8fafc", "&:hover": { backgroundColor: "#f1f5f9" } }}
                    onClick={(e) => {
                      e.stopPropagation();
                      props.archive_shift_change_request(props.uuid);
                    }}
                  >
                    <ArchiveOutlinedIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
              ) : null}
            </div>
          </div>
        </td>
      </tr>
      <PendingTableEmployeeRowShiftDropDrawer
        open={isDrawerOpenDrop}
        onClose={toggleDrawerDrop(false)}
        shiftInfo={props}
        cardStatus={cardStatus}
        rescind_drop_shift={props.rescind_drop_shift}
      />
      <PendingTableEmployeeRowShiftPickupDrawer
        open={isDrawerOpenPickup}
        onClose={toggleDrawerPickup(false)}
        shiftInfo={props}
        cardStatus={cardStatus}
        rescind_pickup_shift={props.rescind_pickup_shift}
      />
    </>
  );
}

export default PendingTableEmployeeRowShift;
